module.exports = __webpack_public_path__ + "img/photo_250720854_1.9a9e07a3.jpg";